export default __webpack_public_path__ + "static/media/Api.163dc3b2.pdf";